import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import Loader from '../ui/loader/Loader';
import { ConsumerRouteList } from '../utils/constants';

import { useUser } from '@/hooks/useUser';
import { useUserStore } from '@/hooks/useUserStore';
import { IReactChildrenProps } from '@/interfaces/IReactChildren';
import { UserRole } from '@/interfaces/api/user/UserRole.enum';
import { AppRoutes } from '@/interfaces/routes/AppRoutes';
import { ConsumerRoutes } from '@/interfaces/routes/ConsumerRoutes';
import { notificationService } from '@/services/notification.service';

const ConsumerGuard = ({ children }: IReactChildrenProps) => {
	const { user, isLoading } = useUser();
	const { store, isLoading: isLoadingStore } = useUserStore();
	const userIsConsumer = user?.roles.includes(UserRole.Consumer);

	useEffect(() => {
		if (!isLoading && (!user || user.roles.length === 0)) {
			notificationService.error(
				'You do not have permission to access this page',
			);
		}
	}, [user, isLoading, isLoadingStore, store]);

	if (isLoading) {
		return (
			<Loader className="flex items-center justify-center h-full w-full" />
		);
	}

	if (user && userIsConsumer) {
		const allowedRoute = ConsumerRouteList.find(
			(route) => route.path === location.pathname,
		);
		if (allowedRoute) {
			return <>{children}</>;
		} else {
			return <Navigate to={ConsumerRoutes.LiveHaggles} />;
		}
	} else {
		return <Navigate to={AppRoutes.UserDashboard} />;
	}
};

export default ConsumerGuard;
